import { createContext, useState } from 'react'

import type {
  CommunitiesSlugMapContextProps,
  CommunitiesSlugMapProviderProps,
  CommunitySlugMap
} from './types'

export const CommunitiesSlugMapContext = createContext<CommunitiesSlugMapContextProps>(
  {} as CommunitiesSlugMapContextProps
)

export const CommunitiesSlugMapProvider = ({ children }: CommunitiesSlugMapProviderProps) => {
  const [communitiesSlugMap, setCommunitiesSlugMap] = useState<CommunitySlugMap[]>([])

  return (
    <CommunitiesSlugMapContext.Provider value={{ communitiesSlugMap, setCommunitiesSlugMap }}>
      {children}
    </CommunitiesSlugMapContext.Provider>
  )
}
